import { WarningOutlined } from '@ant-design/icons';
import { Modal as AModal, Button, Flex } from 'antd';
import ServiceFeeNote from 'components/ServiceFeeNote';
import { applyVoucher } from 'containers/CheckoutPage/actions';
import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import translations from 'translations';
import media from 'utils/mediaStyle';
import utilsMessages from 'utils/messages';
import { VOUCHER_STATUS } from '../../containers/CheckoutPage/constants';
import money from '../../utils/formatMoney';
import SVGIcon from '../SVGIcon/SVGIcon';
import DeliveryFeeSection from './DeliveryFeeSection';
import VoucherPopup from './Voucher/VoucherPopup';
import VoucherTag from './voucherTag.svg';

const FooterCheckout = styled.div`
  max-width: 1180px;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  ${media.md`
    display: flex;
  `}
`;

const LeftComponent = styled.div`
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  padding: 0px 20px;
  height: 100%;
  display: none;

  ${media.md`
    display: flex;
  `}

  ${({ background }) =>
    `
    background: ${background};
  `}
`;

const Divider = styled.div`
  width: 1px;
  height: 40px;
  background: #808289;
`;

const TotalPaymentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: stretch;
  padding: 10px;

  ${media.md`
      align-items: flex-end;
  `}
`;
const TotalPaymentRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;

  ${media.md`
    width: 310px;
  `}
`;
const TotalLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #343538;
  ${media.sm`
    font-size: 14px;
  `}
`;

const TotalValue = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #343538;
`;

const ServiceFeeLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #585a60;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

const ServiceFeeValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #343538;
`;

const TotalDiscount = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #585a60;
`;
const GrossTotal = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #585a60;
  text-decoration: line-through;
`;

const FooterAction = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  ${media.md`
    width: 310px;
  `}
`;

const ButtonWrapper = styled.div`
  width: 100%;
  a,
  button {
    flex: 1;
    width: 100%;
  }
  a {
    display: block;
  }
`;

const FooterCheckoutWrapper = styled.div`
  position: fixed;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff !important;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const VoucherSection = styled(Flex)`
  padding-inline: 16px;
  flex: 1;
  ${media.md`
    padding-inline: 0;
    justify-content: center;
  `}
`;

const VoucherButton = styled(Button)`
  &.ant-btn {
    color: #808289;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    :hover,
    :focus,
    :active {
      background: none;
      color: #43a047;
    }
  }
  ${({ isSelected }) =>
    isSelected &&
    `
    &.ant-btn {
      color: #43a047 !important;
      background: none !important;
    }
  `}
  ${({ isNotValid }) =>
    isNotValid &&
    `
    &.ant-btn {
      color: #F18D13 !important;
      background: none !important;
    }
  `}
`;

const VoucherOnMobile = styled.div`
  background: #efffd6;
  font-size: 12px;
  color: #343538;
  padding: 6px 10px;
  text-align: center;
  display: none;
  @media (max-width: 767px) {
    display: block;
  }
`;

const ConfirmInvalidVoucherModal = styled(AModal)`
  .ant-modal-content {
    padding: 24px 16px 12px;
  }
  .ant-modal-title {
    font-size: 24px;
    font-weight: 500;
    color: #595959;
    margin-bottom: 20px !important;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: center;
    button {
      flex-grow: 1;
    }
    margin-top: 20px !important;
  }
`;

const ConfirmModalTitle = styled.div`
  font-size: 18px;
  margin: -8px -16px 0;
  padding: 0 16px;
  text-align: center;
`;

const RemoveVoucherButton = styled(Button)`
  border-radius: 4px !important;
  border-color: #7cca84;
  color: #4b9c63;
`;

const ConfirmContentModal = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: #585a60;
`;

const voucherStatusMessages = (voucherStatus: VOUCHER_STATUS | null) => {
  switch (voucherStatus) {
    case VOUCHER_STATUS.INVALID:
    case VOUCHER_STATUS.EXPIRED:
    case VOUCHER_STATUS.NOT_SATISFIED:
      return utilsMessages.voucherInvalid;
    case VOUCHER_STATUS.APPLIED:
      return utilsMessages.voucherApplied;
    default:
      return utilsMessages.voucherButton;
  }
};

interface IDispatch {
  onApplyVoucher: (data: any) => void;
}
interface CheckoutFooterProps {
  deliveryFee: any;
  subTotal: number;
  cart: any;
  orderDisabled: boolean;
  loading?: boolean;
  onGoNext: () => void;
  onGoBack?: () => void;

  // voucher
  discountValue: number;
  isMobile: boolean;
  voucherStatus: VOUCHER_STATUS | null;
  getVouchers?: (data: any) => void;
}

type Props = CheckoutFooterProps & IDispatch;

const CheckoutFooter = (props: Props) => {
  const {
    deliveryFee,
    cart,
    orderDisabled,
    onGoNext,
    onGoBack,
    subTotal,
    loading,
    voucherStatus,
    isMobile,
    getVouchers,
    discountValue,
    onApplyVoucher,
  } = props;

  const [isOpenVoucher, setIsOpenVoucher] = useState(false);
  const [isOpenConfirmInvalidVoucherPopup, setIsOpenConfirmInvalidVoucherPopup] = useState(false);

  const isLessThanMOQ = useMemo(
    () => (cart?.store?.moq ? subTotal < cart?.store?.moq : false),
    [cart?.store?.moq, subTotal],
  );
  const isNotValid = useMemo(() => voucherStatus && voucherStatus !== VOUCHER_STATUS.APPLIED, [voucherStatus]);

  const totalDiscount = useMemo(() => {
    // All discount type logic here
    const deliveryFeeDiscount = !isLessThanMOQ && deliveryFee?.isFreeDelivery ? deliveryFee?.fee : 0;
    const discountVoucher = discountValue > 0 ? discountValue : 0;

    return deliveryFeeDiscount + discountVoucher;
  }, [deliveryFee, discountValue, isLessThanMOQ]);

  const netTotal = useMemo(() => {
    const serviceFee =
      isLessThanMOQ || deliveryFee?.isFreeDelivery
        ? 0
        : Number(deliveryFee?.fee || 0) + Number(deliveryFee?.additionalVat || 0);
    const discountVoucher = discountValue > 0 ? discountValue : 0;

    return subTotal + serviceFee - discountVoucher;
  }, [subTotal, deliveryFee, discountValue, isLessThanMOQ]);

  const grossTotal = useMemo(() => {
    return (netTotal || 0) + totalDiscount;
  }, [netTotal, totalDiscount]);

  // Voucher
  const onClickVoucher = () => {
    setIsOpenVoucher(true);
    if (getVouchers) {
      getVouchers({ total: subTotal });
    }
  };

  return (
    <FooterCheckoutWrapper>
      <FooterCheckout>
        <VoucherOnMobile>
          <FormattedMessage {...utilsMessages.voucherMobile} />
        </VoucherOnMobile>
        <LeftComponent background={isLessThanMOQ ? 'rgba(255, 247, 214, 0.40)' : 'rgba(239, 255, 214, 0.40)'}>
          <DeliveryFeeSection deliveryFee={deliveryFee} subTotal={subTotal} cartMoq={cart?.store?.moq} />
          <Divider />
          <VoucherSection justify="space-between" align="center" vertical={!isMobile}>
            <Flex gap={4} align="center" style={{ cursor: 'pointer', minWidth: 160, position: 'relative' }}>
              <SVGIcon src={VoucherTag} />
              <FormattedMessage {...utilsMessages.voucherLabel} />
            </Flex>
            <VoucherButton
              onClick={onClickVoucher}
              iconPosition="start"
              icon={isNotValid ? <WarningOutlined /> : null}
              color="default"
              isNotValid={isNotValid}
              type="text"
              isSelected
            >
              <FormattedMessage {...voucherStatusMessages(voucherStatus)} />
            </VoucherButton>
          </VoucherSection>
        </LeftComponent>
        <VoucherPopup total={subTotal} open={isOpenVoucher} setOpen={setIsOpenVoucher} />

        <TotalPaymentSection>
          <div>
            {!isLessThanMOQ && !deliveryFee?.isFreeDelivery && (
              <TotalPaymentRow>
                <ServiceFeeLabel>
                  <FormattedMessage {...utilsMessages.serviceFee} />
                  <ServiceFeeNote
                    deliveryFeeThreshold={cart?.deliveryFee?.deliveryFeeThreshold}
                    moq={cart?.store?.moq}
                    deliveryFee={cart?.deliveryFee?.fee}
                    areaGroupName={cart?.deliveryFee?.areaGroupName}
                  />
                </ServiceFeeLabel>
                <ServiceFeeValue>{money(deliveryFee?.fee || 0)}đ</ServiceFeeValue>
              </TotalPaymentRow>
            )}
            <TotalPaymentRow>
              <TotalLabel>
                <FormattedMessage {...utilsMessages.total} />
              </TotalLabel>
              <TotalValue>{money(netTotal)}đ</TotalValue>
            </TotalPaymentRow>

            {!!totalDiscount && (
              <TotalPaymentRow>
                <TotalDiscount>
                  <FormattedMessage
                    {...utilsMessages.totalDiscount}
                    values={{
                      discount: money(totalDiscount),
                    }}
                  />
                </TotalDiscount>
                <GrossTotal>{money(grossTotal)}đ</GrossTotal>
              </TotalPaymentRow>
            )}
          </div>
          <FooterAction>
            {onGoBack && (
              <ButtonWrapper>
                <Button size="large" onClick={onGoBack}>
                  <FormattedMessage {...utilsMessages.back} />
                </Button>
              </ButtonWrapper>
            )}
            <ButtonWrapper>
              <Button
                type="primary"
                disabled={orderDisabled || isLessThanMOQ || !deliveryFee?.fee}
                size="large"
                loading={loading}
                onClick={() => {
                  if (isNotValid) {
                    setIsOpenConfirmInvalidVoucherPopup(true);
                    return;
                  }
                  onGoNext();
                }}
              >
                <FormattedMessage {...utilsMessages.next} />
              </Button>
            </ButtonWrapper>
          </FooterAction>
        </TotalPaymentSection>
      </FooterCheckout>
      <ConfirmInvalidVoucherModal
        open={isOpenConfirmInvalidVoucherPopup}
        title={
          <ConfirmModalTitle>
            <FormattedMessage {...utilsMessages.voucherConfirmTitle} />
          </ConfirmModalTitle>
        }
        centered
        onOk={() => {
          setIsOpenConfirmInvalidVoucherPopup(false);
          onClickVoucher();
        }}
        onCancel={() => setIsOpenConfirmInvalidVoucherPopup(false)}
        closable={false}
        okText={translations(utilsMessages.viewVoucher)}
        okButtonProps={{
          size: 'large',
          style: {
            borderRadius: '4px',
          },
        }}
        cancelButtonProps={{
          size: 'large',
          style: {
            borderRadius: '4px',
          },
        }}
        footer={(_, { OkBtn }) => (
          <>
            <RemoveVoucherButton
              size="large"
              onClick={() => {
                onApplyVoucher({});
                setIsOpenConfirmInvalidVoucherPopup(false);
              }}
            >
              <FormattedMessage {...utilsMessages.removeVoucher} />
            </RemoveVoucherButton>
            <OkBtn />
          </>
        )}
      >
        <ConfirmContentModal>
          <FormattedMessage {...utilsMessages.voucherConfirmContent} />
        </ConfirmContentModal>
      </ConfirmInvalidVoucherModal>
    </FooterCheckoutWrapper>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatch => ({
  onApplyVoucher: (data: any) => dispatch(applyVoucher(data)),
});

export default connect(() => {}, mapDispatchToProps)(CheckoutFooter);
